// Chakra imports
import { 
	Flex, 
	FormLabel, 
	Input, 
	Text, 
	useColorModeValue,
	Box 
  } from '@chakra-ui/react';
  
  export default function Default(props: {
	id?: string;
	label?: string;
	extra?: JSX.Element;
	placeholder?: string | JSX.Element;
	type?: string;
	required?: boolean;
	isInvalid?: boolean;
	isReadOnly?: boolean;
	value?: any;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	mb?: string;
	[x: string]: any;
  }) {
	const { 
	  id, 
	  label, 
	  extra, 
	  placeholder, 
	  type, 
	  mb, 
	  required, 
	  isInvalid,
	  isReadOnly,
	  value,
	  onChange,
	  ...rest 
	} = props;
	
	// 🎨 Colores más sofisticados
	const textColorPrimary = useColorModeValue('gray.800', 'whiteAlpha.900');
	const textColorSecondary = useColorModeValue('gray.500', 'gray.400');
	const bgPrimary = useColorModeValue('gray.50', 'gray.700');
	const borderColor = useColorModeValue('gray.200', 'gray.600');
	const focusBorderColor = useColorModeValue('blue.400', 'blue.300');
	const hoverBorderColor = useColorModeValue('gray.300', 'gray.500');
	const invalidBorderColor = useColorModeValue('red.400', 'red.300');
	const readOnlyBg = useColorModeValue('gray.100', 'gray.800');
	const readOnlyColor = useColorModeValue('gray.600', 'gray.300');
  // Colores para hover y focus
const hoverBg = useColorModeValue('white', 'gray.600');
const focusBg = useColorModeValue('white', 'gray.600');

	return (
	  <Flex direction="column" mb={mb ?? '24px'} width="100%">
		{label && (
		  <FormLabel
			htmlFor={id}
			fontSize="sm"
			color={textColorPrimary}
			fontWeight="semibold"
			mb="6px"
		  >
			{label}
			{required && <Text as="span" color="red.400" ml="1">*</Text>}
			{extra && (
			  <Text fontSize="xs" ml="2" color={textColorSecondary} fontWeight="normal">
				{extra}
			  </Text>
			)}
		  </FormLabel>
		)}
  
		<Box position="relative">
		  <Input
			{...rest}
			type={type}
			id={id}
			fontWeight="medium"
			variant="outline"
			placeholder={typeof placeholder === 'string' ? placeholder : undefined}
			fontSize="sm"
			borderRadius="10px"
			borderWidth="1px"
			borderColor={isInvalid ? invalidBorderColor : borderColor}
			color={isReadOnly ? readOnlyColor : textColorPrimary}
			bg={isReadOnly ? readOnlyBg : bgPrimary}
			transition="all 0.2s ease"
			_placeholder={{ 
			  fontWeight: 'normal', 
			  color: textColorSecondary,
			}}
			_hover={{
				borderColor: isInvalid ? invalidBorderColor : hoverBorderColor,
				bg: isReadOnly ? readOnlyBg : hoverBg,
				boxShadow: 'sm',
			  }}
			  _focus={{
				borderColor: isInvalid ? invalidBorderColor : focusBorderColor,
				bg: isReadOnly ? readOnlyBg : focusBg,
				boxShadow: `0 0 0 2px ${isInvalid ? invalidBorderColor : focusBorderColor}`,
			  }}
			_disabled={{
			  opacity: 0.6,
			  cursor: 'not-allowed'
			}}
			_readOnly={{
			  bg: readOnlyBg,
			  color: readOnlyColor,
			  cursor: 'default'
			}}
			value={value}
			onChange={onChange}
			isInvalid={isInvalid}
			isReadOnly={isReadOnly}
		  />
		</Box>
  
		{typeof placeholder !== 'string' && placeholder}
	  </Flex>
	);
  }
  